import { EmailValidator } from 'commons-validator-js';
const emailValidator = new EmailValidator();
export default [
	function () {
		return {
			require: '^ngModel',
			link: function ($scope, $element, attrs, ngModelCtrl) {
				ngModelCtrl.$validators.invalid = function (modelValue, viewValue) {
					var value = '' + (modelValue || viewValue || '');

					if (!attrs.required && !value) {
						return true;
					}

					return emailValidator.isValid(value);
				};
			}
		};
	}
];
